import React from "react";
import { motion } from "framer-motion";
import { Star, BadgeCheck, Quote } from "lucide-react";

const REVIEWS = [
  {
    name: "Rahul Sharma",
    role: "Back Pain Patient",
    text: "I had severe back pain for years. Within two weeks I felt completely different. Highly recommended.",
  },
  {
    name: "Priya Verma",
    role: "Cervical Patient",
    text: "Very professional doctor. Home visit service saved a lot of time.",
  },
  {
    name: "Amit Singh",
    role: "Knee Pain Patient",
    text: "My knee pain reduced significantly after regular physiotherapy sessions.",
  },
  {
    name: "Neha Gupta",
    role: "Sports Injury",
    text: "Excellent treatment and very polite behaviour.",
  },
  {
    name: "Rakesh Yadav",
    role: "Paralysis Rehab",
    text: "My father's paralysis rehabilitation showed great improvement.",
  },
];

const initials = (name) =>
  name
    .split(" ")
    .map((n) => n[0])
    .slice(0, 2)
    .join("");

export const Testimonials = () => (
  <section
    id="testimonials"
    data-testid="testimonials-section"
    className="py-20 sm:py-28 lg:py-32 bg-white"
  >
    <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
      <div className="max-w-3xl">
        <p className="text-xs sm:text-sm text-brand-600 font-semibold tracking-[0.18em] uppercase">
          Patient Stories
        </p>
        <h2 className="mt-3 font-display text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight text-slate-900">
          Real recoveries, <em className="not-italic bg-gradient-to-r from-brand-400 to-accent-400 bg-clip-text text-transparent">real people</em>.
        </h2>
      </div>

      <div className="mt-12 sm:mt-16 grid sm:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
        {REVIEWS.map((r, i) => (
          <motion.figure
            key={r.name}
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.5, delay: (i % 3) * 0.08 }}
            data-testid={`testimonial-${i}`}
            className="relative p-7 rounded-3xl bg-white border border-slate-100 shadow-[0_8px_30px_rgb(0,0,0,0.03)] hover:shadow-[0_20px_50px_rgb(0,0,0,0.07)] transition-all"
          >
            <Quote className="absolute -top-3 right-6 w-8 h-8 text-brand-100" strokeWidth={1.4} />
            <div className="flex items-center gap-0.5">
              {Array.from({ length: 5 }).map((_, idx) => (
                <Star
                  key={idx}
                  className="w-4 h-4 fill-amber-400 text-amber-400"
                />
              ))}
            </div>
            <blockquote className="mt-4 text-slate-700 leading-relaxed">
              "{r.text}"
            </blockquote>
            <figcaption className="mt-6 flex items-center gap-3">
              <span className="w-10 h-10 rounded-full bg-gradient-to-br from-brand-500 to-accent-500 flex items-center justify-center text-white font-semibold text-sm">
                {initials(r.name)}
              </span>
              <div className="flex-1">
                <p className="text-sm font-semibold text-slate-900 flex items-center gap-1">
                  {r.name}
                  <BadgeCheck className="w-4 h-4 text-accent-500" strokeWidth={1.8} />
                </p>
                <p className="text-xs text-slate-500">{r.role}</p>
              </div>
            </figcaption>
          </motion.figure>
        ))}
      </div>
    </div>
  </section>
);
